import Container from '@components/container';
import Vimeo from '@components/vimeo';
import { ContainerSize, Vimeo as VimeoType } from '@lib/types';

export default function VimeoSection({
  data: { vimeoUrl, videoPreset, videoStartAtSecond },
}: {
  data: VimeoType;
}) {
  return (
    <Container size={ContainerSize.wide}>
      <div className="lg:grid grid-cols-12 gap-1.5 md:gap-6">
        <div className="col-start-3 col-span-8 rounded-xl md:rounded-3xl overflow-hidden">
          <Vimeo
            url={vimeoUrl}
            preset={videoPreset}
            start={videoStartAtSecond}
          />
        </div>
      </div>
    </Container>
  );
}
